import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=7acc3948&scoped=true"
import script from "./ProjectTree.vue?vue&type=script&lang=js"
export * from "./ProjectTree.vue?vue&type=script&lang=js"
import style0 from "./ProjectTree.vue?vue&type=style&index=0&id=7acc3948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc3948",
  null
  
)

export default component.exports